import React from "react";

import CloseIcon from "../../assets/icons/CloseIcon";
import TopPicksIcon from "../../assets/icons/topPicks";
import { HeaderProps } from "../../types/interface.types";
import {
  HeaderContainer,
  HeaderTitleContainer,
  LeftContainer,
  RightContainer,
  SeeAllContainer,
  SeeAllText,
  TitleIconContainer,
  TitleText,
} from "./index.styles";

const Header: React.FC<HeaderProps> = ({
  title,
  showTitleIcon,
  showSeeAll,
  showClose,
  onClickSeeAll,
  onClickClose,
  type,
}) => {
  const renderLeftIcon = () => {
    return (
      <TitleIconContainer>
        <TopPicksIcon />
      </TitleIconContainer>
    );
  };

  const renderTitle = () => {
    return (
      <HeaderTitleContainer>
        {showTitleIcon && renderLeftIcon()}
        <TitleText showTitleIcon={showTitleIcon}>{title}</TitleText>
      </HeaderTitleContainer>
    );
  };
const renderSeeAll = () => {
  return (
    <SeeAllContainer onClick={onClickSeeAll}>
      <SeeAllText>
        View All
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#00BCB4"
          viewBox="0 0 256 256"
        >
          <path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path>
        </svg>
      </SeeAllText>
    </SeeAllContainer>
  );
};

  const renderCloseIcon = () => {
    return (
      <SeeAllContainer onClick={onClickClose}>
        <CloseIcon />
      </SeeAllContainer>
    );
  };

  return (
    <HeaderContainer type={type}>
      <LeftContainer>{renderTitle()}</LeftContainer>
      {showSeeAll && <RightContainer>{renderSeeAll()}</RightContainer>}
      {showClose && <RightContainer>{renderCloseIcon()}</RightContainer>}
    </HeaderContainer>
  );
};

export default Header;
